import React, { createContext, useMemo, useContext } from 'react';
import Axios from 'axios';


const AxiosContext = createContext();

export function AxiosProvider({ children }) {
  const devBaseUrl = process.env.REACT_APP_API;
  const productionBaseUrl = process.env.REACT_APP_API;

  const axios = useMemo(() => {
    const axios = Axios.create({
      headers: {
        'Content-Type': 'application/json'
      }
    });

    axios.interceptors.request.use((config) => {
      // Read token for anywhere, in this case directly from localStorage
      if (String(window.location.href).indexOf('localhost') > -1) {
        config.baseURL = devBaseUrl;
      } else {
        config.baseURL = productionBaseUrl;
      }
      const token = localStorage.getItem('accessToken');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    return axios;
  }, []);

  return <AxiosContext.Provider value={axios}>{children}</AxiosContext.Provider>;
}

export function useAxios() {
  return useContext(AxiosContext);
}

export function customInterIceptors() {
  const API = Axios.create({ baseURL: process.env.REACT_APP_API });
  return API;
}
